<div class="loader-body" data-qa-block="preloader">
  <div class="dot"></div>
  <div class="dot"></div>
  <div class="dot"></div>
  <span class="text">{{ 'common.loader.downloading' | translate }}...</span>
</div>
